var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDiscount = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 26,
  height: 33,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#4A4A4A",
  d: "M6.567 0h15.766v26.4a6.6 6.6 0 0 1-6.6 6.6H2.167V4.4a4.4 4.4 0 0 1 4.4-4.4"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#4A4A4A",
  d: "M9.5 0h14.667v28.6a4.4 4.4 0 0 1-4.4 4.4H9.5z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#discount_svg__a)",
  d: "M9.5 0h14.667v28.6a4.4 4.4 0 0 1-4.4 4.4H9.5z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M19.584 5.5a.916.916 0 0 1 0 1.832H6.749a.916.916 0 0 1 0-1.832zM19.584 10.999a.916.916 0 1 1 0 1.832H6.749a.916.916 0 1 1 0-1.832zM14.084 16.498a.916.916 0 0 1 0 1.832H6.749a.916.916 0 0 1 0-1.832z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "discount_svg__a",
  x1: 24.35,
  x2: 9.5,
  y1: -5.775,
  y2: 33,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#F4F8FC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.672,
  stopColor: "#568DFE"
})))));
export default SvgDiscount;